import { useQuery } from "@apollo/client";
import {GET_CAMPAIGNS_WAITING } from '../../../utils/api/campaign';
import HomeList from "./HomeList";

const WaitingList = () => {
  const {
    loading,
    error,
    data,
  } = useQuery(GET_CAMPAIGNS_WAITING);

  const campaigns = data?.campaigns || []
  
  return <HomeList campaigns={campaigns} error={error} loading={loading}/>
};

export default WaitingList;
